<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Listado de tipologías de actividad por duración del sistema
            </div>
            <div class="card-body">
                <div>
                    <div class="mb-1">
                        <b-dropdown
                            size="lg"
                            variant="link"
                            toggle-class="text-decoration-none"
                            class="float-right"
                            no-caret
                        >
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item>
                                <div v-b-modal="'addActivityDurationType'">
                                    <i class="fa fa-plus-circle mr-2 fa-fw"/> Nueva
                                </div>
                                <admin-add-activity-duration-type-modal />
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <table  class="table table-hover table-bordered table-sm mt-1">
                        <thead>
                            <tr>
                                <th scope="col" title="Nombre">Nombre</th>
                                <th scope="col" title="Código">Código</th>
                                <th scope="col" title="Precio guía">Precio guía</th>
                                <th scope="col" title="Id interno">Id interno</th>
                                <th scope="col" title="Creada">Creada</th>
                                <th scope="col" title="Actualizada">Actualizada</th>
                                <th scope="col" title="Acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loadingSync">
                            <admin-activity-duration-types-row v-for="type in activityDurationTypes" :key="type.id" :row="type" />
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="4">Actualizando el listado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
/* eslint-disable */
import AdminActivityDurationTypesRow from './AdminActivityDurationTypesRow'
import AdminAddActivityDurationTypeModal from './AdminAddActivityDurationTypeModal';
import { mapGetters } from "vuex";

export default {
    components: {
        AdminActivityDurationTypesRow,
        AdminAddActivityDurationTypeModal
    },
    data: function () {
        return {
            loadingSync: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(["activityDurationTypes"])
    },
    async mounted() {
        this.loadingSync = true
        await this.$store.dispatch("activityDurationTypes/retrieveActivityDurationTypes")
        this.loadingSync = false
    }
}
</script>